import { State } from 'redux/utils/Send'

export default State()